import { Select } from 'antd';
import React, { forwardRef } from 'react';
import styles from '../CreateNewWorkScheduleByPeriod.module.scss';

const { Option: SelectOption } = Select;

const isDefinedValue = (value) => value !== undefined && value !== null;

const getOptionText = (option = {}) =>
  option.text || option.content || option.label || option.value;

const getOptionSearch = (option = {}, createSearch) =>
  String(
    (typeof createSearch === 'function' && createSearch(option)) ||
      option.search ||
      option.text ||
      option.label ||
      option.value ||
      ''
  );

const filterSelectOption = (searchValue, option) =>
  String(option.props.search || '')
    .toLowerCase()
    .includes(String(searchValue || '').toLowerCase());

const StyledSelect = forwardRef(function StyledSelect(
  {
    className,
    createSearch,
    disabled,
    id,
    label,
    loading,
    multiple,
    name,
    onChange,
    options = [],
    placeholder,
    value,
  },
  ref
) {
  const selectValue = multiple
    ? Array.isArray(value)
      ? value
      : []
    : Array.isArray(value)
    ? value[0]
    : value;

  const handleChange = (nextValue) => {
    if (typeof onChange !== 'function') {
      return;
    }

    if (multiple) {
      onChange(nextValue || []);
      return;
    }

    onChange(isDefinedValue(nextValue) ? nextValue : undefined);
  };

  return (
    <Select
      ref={ref}
      className={[styles.dropdownSelect, styles.addressSelect, className]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled}
      id={id}
      loading={loading}
      name={name}
      value={selectValue}
      mode={multiple ? 'multiple' : undefined}
      allowClear
      showSearch
      placeholder={placeholder || label}
      optionFilterProp="search"
      optionLabelProp="label"
      filterOption={filterSelectOption}
      onChange={handleChange}
    >
      {options.map((option) => {
        const optionText = getOptionText(option);

        return (
          <SelectOption
            key={option.key ?? option.value}
            value={option.value}
            disabled={option.disabled}
            search={getOptionSearch(option, createSearch)}
            label={optionText}
          >
            {option.content || optionText}
          </SelectOption>
        );
      })}
    </Select>
  );
});

export default StyledSelect;
